export default __webpack_public_path__ + "static/media/icon-add-detail.42b902a3.svg";